import { cn } from '@/package';

const style = {
  tenantItemContainer: (valid?: boolean) =>
    cn(
      'w-full rounded-md !border border-gray-300 px-4 py-2 hover:border-blue-300',
      valid ? 'border-error-500' : '',
      'active:border-blue-300 active:bg-skyBlue-200',
      'aria-disabled:border-gray-200 aria-disabled:bg-gray-200 aria-disabled:text-gray-400',

      'hover:relative',
      'hover:after:absolute hover:after:top-0 hover:after:left-0',
      'hover:after:h-full hover:after:w-full',
      'hover:after:rounded-md',
      'hover:after:content-[""]',
      'hover:after:shadow-sm',
      'hover:after:z-[1]',
    ),

  tenantItemText: (disabled?: boolean) =>
    cn(!disabled ? 'text-black' : 'text-gray-400'),

  tenantItemSubText: (disabled?: boolean) =>
    cn(
      'text-body-md text-nowrap',
      !disabled ? 'text-gray-500' : 'text-gray-400',
    ),

  tenantItemArrowIcon: (disabled?: boolean) =>
    cn(!disabled ? 'fill-black' : 'fill-gray-300'),

  tenantItemMessage: (valid?: boolean) =>
    cn('px-2 text-body-md', !valid ? 'text-gray-500' : 'text-error-500'),
} as const;

export default style;
